import { injectable } from 'inversify'

@injectable()
export class LinkCreator {
  protected config: ReturnType<typeof useRuntimeConfig>

  constructor() {
    this.config = useRuntimeConfig()
  }

  getBase() {
    return this.normalizeUri(
      `${
        import.meta.server
          ? this.config.API_BASE_URL
          : this.config.public.API_BASE_URL
      }/`,
    )
  }

  getLink(link: string) {
    return this.normalizeUri(this.getBase() + link)
  }

  protected normalizeUri(uri: string) {
    return uri.replaceAll(/([^:]\/)\/+/g, '$1')
  }
}
